"use client"

import { useEffect, useState } from "react"
import { useLayoutContext } from "@src/layouts/provider"
import { getCurrencyCodeFromCookie } from "@src/api/lib/currencyUtils"
import { formatCurrency } from "@src/utils/currency"
import { useTranslation } from "react-i18next"

interface Props {
  price,
  currency?: string
}

const FormattedPrice = ({ price, currency }: Props) => {
  const { i18n } = useTranslation()
  const { currencyRates } = useLayoutContext()
  const [resolvedCurrency, setResolvedCurrency] = useState(currency || "VND")

  useEffect(() => {
    if (!currency) {
      setResolvedCurrency(getCurrencyCodeFromCookie())
    }
  }, [currency])

  return <>{formatCurrency(price ? price : 0, currencyRates, i18n.language, resolvedCurrency)}</>
}

export default FormattedPrice;
